"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDailyStatId(ownerId, statName) {
    const d = new Date();
    return `${statName}-${ownerId}-${d.getDay()}-${d.getMonth()}-${d.getFullYear()}`;
}
exports.default = getDailyStatId;
